var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFlashFilled = function SvgFlashFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 14 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10.48.12a1 1 0 0 1 .5 1.05L10.19 6H13a1 1 0 0 1 .7 1.7l-8 8a1 1 0 0 1-1.69-.87l.8-4.83H1a1 1 0 0 1-.66-1.75l9-8a1 1 0 0 1 1.14-.13",
    clipRule: "evenodd"
  })));
};
export default SvgFlashFilled;